import React from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaTooltip from "../../../../ui-kit/kuika-tooltip/kuika-tooltip";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { VariantGrid } from "../_layout/variant-grid";

type TooltipPosition = "top" | "right" | "bottom" | "left";
type TooltipColor = "green" | "red" | "yellow" | "none";

const POSITIONS: TooltipPosition[] = ["top", "right", "bottom", "left"];
const COLORS: TooltipColor[] = ["green", "red", "yellow", "none"];
const TOOLBAR_ACTIONS: string[] = ["Undo", "Redo", "Preview", "Publish"];

export const TooltipStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Tooltip"
      componentName="KuikaTooltip"
      sourcePath="ui-kit/kuika-tooltip"
      description="Radix-backed tooltip. Four positions, four background tones and configurable delay/align."
    >
      <VariantGrid
        label="position"
        cols={POSITIONS}
        cellMinWidth={140}
        render={(position: string): React.ReactNode => (
          <KuikaTooltip content={`${position} tooltip`} position={position as TooltipPosition} defaultOpen>
            <KuikaButton type="secondary" size="sm">
              {position}
            </KuikaButton>
          </KuikaTooltip>
        )}
      />
      <VariantGrid
        label="background color"
        cols={COLORS}
        cellMinWidth={140}
        render={(color: string): React.ReactNode => (
          <KuikaTooltip content={`${color} tone`} position="top" bgcolor={color as TooltipColor} defaultOpen>
            <KuikaButton type="secondary" size="sm">
              {color}
            </KuikaButton>
          </KuikaTooltip>
        )}
      />
      <SpecRow label="With delay" caption="delayDuration=600">
        <KuikaTooltip content="Hover-only, 600 ms delay" delayDuration={600}>
          <KuikaButton type="secondary" size="sm">
            slow hover
          </KuikaButton>
        </KuikaTooltip>
      </SpecRow>
      <SpecRow label="With alignment" caption="align='start' | 'center' | 'end'">
        <KuikaTooltip content="start" position="bottom" align="start" defaultOpen>
          <KuikaButton type="secondary" size="sm">
            start
          </KuikaButton>
        </KuikaTooltip>
        <KuikaTooltip content="center" position="bottom" align="center" defaultOpen>
          <KuikaButton type="secondary" size="sm">
            center
          </KuikaButton>
        </KuikaTooltip>
        <KuikaTooltip content="end" position="bottom" align="end" defaultOpen>
          <KuikaButton type="secondary" size="sm">
            end
          </KuikaButton>
        </KuikaTooltip>
      </SpecRow>
      <SpecRow label="Warm-up" caption="hover one, then slide along — the next opens at once">
        <div style={{ display: "flex", gap: 4 }}>
          {TOOLBAR_ACTIONS.map((action: string): JSX.Element => (
            <KuikaTooltip key={action} content={action} position="bottom">
              <KuikaButton type="secondary" size="sm">
                {action.charAt(0)}
              </KuikaButton>
            </KuikaTooltip>
          ))}
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
